import { useQuery } from '@tanstack/react-query';

import { orpc } from '@/api/rpc/client';
import { BUILT_IN_HUBBELL_LAYOUT } from './hubbellLayout';
import { BUILT_IN_ROCKWELL_LAYOUT } from './rockwellLayout';
import { BUILT_IN_STELPRO_LAYOUT } from './stelproLayout';
import { availableSupplierLayouts } from './supplierLayouts';

/** Built-in suppliers, each offered until the org saves its own of that name. */
const BUILT_IN_LAYOUTS = [
  BUILT_IN_ROCKWELL_LAYOUT,
  BUILT_IN_STELPRO_LAYOUT,
  BUILT_IN_HUBBELL_LAYOUT,
];

/** The org's supplier layouts and validation rules, with safe empty defaults. */
export function useUploadToolData() {
  const layoutsQuery = useQuery(
    orpc.pricing.uploadLayouts.list.queryOptions({ input: {} }),
  );
  const rulesQuery = useQuery(
    orpc.pricing.uploadRules.list.queryOptions({ input: {} }),
  );
  const unreadableRuleIds = rulesQuery.data?.unreadableRuleIds ?? [];
  const unreadableLayoutIds = layoutsQuery.data?.unreadableLayoutIds ?? [];
  const layouts = layoutsQuery.data?.layouts ?? [];
  return {
    layouts,
    /** The saved layouts have loaded, so the supplier list is final. */
    layoutsReady: layoutsQuery.isSuccess,
    /** The suppliers a file can be converted for. */
    supplierLayouts: availableSupplierLayouts(layouts, BUILT_IN_LAYOUTS),
    unreadableLayoutIds,
    rules: rulesQuery.data?.rules ?? [],
    unreadableRuleIds,
    rulesLoading: rulesQuery.isLoading,
    rulesError: rulesQuery.isError,
    /**
     * Never download against rules or layouts that did not load or cannot be
     * read: an unreadable saved layout could be the one the file needs, and
     * its scoped Block rules would go unchecked.
     */
    downloadReady:
      rulesQuery.isSuccess &&
      layoutsQuery.isSuccess &&
      unreadableRuleIds.length === 0 &&
      unreadableLayoutIds.length === 0,
  };
}
